module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "be-wrapper"
  }, [_vm._c('navbar'), _vm._v(" "), _vm._c('router-view'), _vm._v(" "), _vm._c('footer-nav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4685eb97!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/layouts/Home.vue
// module id = 654
// module chunks = 1